<template>
  <div class="manager-tab__mobile" @click="activateModal">
    <div class="manager-tab__mobile-image" :style="`background-image: url(${item.headshot})`">
      <div class="manager-tab__mobile-angle-block"></div>
    </div>
    <div class="manager-tab__mobile-identity">
      <p>Contact<br/><strong>{{ item.title }}</strong></p>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'ContactTeamMobileItem',
    components: {},
    props: {
      item: {
        type: Object,
      },
      modalKey: {
        type: String,
        default: '',
      },
    },
    computed: {
      ...mapGetters('main', ['fuelEmployee']),
    },
    methods: {
      deactivateModals() {
        this.$store.dispatch('main/showModal', false);
      },
      activateModal() {
        this.$store.dispatch('main/showModal', this.modalKey);
      //   if (this.fuelEmployee) {
      //     alert('This functionality is reserved for members only.');
      //   } else {
      //     this.$store.dispatch('main/showModal', this.modal);
      //   }
      },
    }
  };
</script>
